import { render, staticRenderFns } from "./VehicleDetails.vue?vue&type=template&id=56fc6ba8&scoped=true"
import script from "./VehicleDetails.vue?vue&type=script&lang=ts"
export * from "./VehicleDetails.vue?vue&type=script&lang=ts"
import style0 from "./VehicleDetails.vue?vue&type=style&index=0&id=56fc6ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fc6ba8",
  null
  
)

export default component.exports